import React from "react";
import { Box, CircularProgress, MenuItem, Typography } from "@mui/material";

export default function NotificationMenuState({
  loading,
  error,
  onRetry,
}: {
  loading: boolean;
  error: boolean;
  onRetry: () => void;
}) {
  if (loading) {
    return (
      <MenuItem disabled>
        <CircularProgress size={16} sx={{ mr: 1 }} />
        <Typography variant="body2" color="text.secondary">Checking notifications…</Typography>
      </MenuItem>
    );
  }
  if (error) {
    return (
      <MenuItem onClick={onRetry}>
        <Box>
          <Typography variant="body2" color="warning.main" fontWeight={600}>
            Couldn't read notifications.
          </Typography>
          <Typography variant="caption" color="text.secondary">Try again</Typography>
        </Box>
      </MenuItem>
    );
  }
  return (
    <MenuItem disabled>
      <Typography variant="body2" color="text.secondary">Nothing to report</Typography>
    </MenuItem>
  );
}
